// Maps timeline tab names to the activity keys that should appear
// in the pinned section for that tab.
// null = show all pinned activities (All tab).
// Mirrors the backend ACTIVITY_TYPE_MAP keys for each tab, except:
// - 'notes' tab: PIN_TAB_KEYS uses only ['lead.note'] (the user-created note),
//   while ACTIVITY_TYPE_MAP['notes'] is a composite that also includes
//   text_message, email, and phone_call (those have their own tabs here).
// - 'changes' tab is excluded (change activities are not pinnable).
// - 'tasks' tab is excluded (task entries are change activities, not pinnable).

const PIN_TAB_KEYS = {
  all:          null,
  notes:        ['lead.note'],
  emails:       ['lead.email', 'lead.email_sent', 'lead.campaign_email_sent',
                 'lead.forwarded_email', 'lead.forwarded_email_reply',
                 'lead.bcc_email', 'lead.email_scheduled',
                 'lead.email_schedule_updated', 'lead.email_schedule_canceled'],
  calls:        ['lead.phone_call'],
  texts:        ['lead.sms_conversation', 'lead.text_message',
                 'lead.text_message_scheduled', 'lead.text_message_schedule_updated',
                 'lead.text_message_schedule_canceled'],
  appointments: ['lead.appointment', 'lead.appointment_saved', 'lead.appointment_sent'],
};

export default PIN_TAB_KEYS;
